import { Link, NavLink } from 'react-router-dom';
import { FaGraduationCap, FaHeart, FaShareAlt, FaNewspaper } from 'react-icons/fa';
import { useState } from 'react';
import { useChoiceList } from '../../context/ChoiceListContext';
import { toast } from 'react-toastify';
import { SITE_CONFIG } from '../../config/siteConfig';

const SHARE_DATA = {
  title: 'ChooseMyCollege — Free TNEA Guidance',
  text: `Free TNEA ${SITE_CONFIG.year} college predictor & counselling tool. Find colleges by your cutoff or rank!`,
  url: 'https://choosemycollege.in',
};

const handleShare = async () => {
  if (navigator.share) {
    try { await navigator.share(SHARE_DATA); } catch { /* user cancelled */ }
  } else {
    await navigator.clipboard.writeText(SHARE_DATA.url);
    toast.success('Link copied to clipboard!', { autoClose: 2000 });
  }
};

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { choiceList } = useChoiceList();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/predictor', label: 'College Predictor' },
    { path: '/cutoffs', label: 'Compare College', subtitle: 'Cutoff | Rank' },
    { path: '/colleges', label: 'Colleges' },
    { path: '/best-colleges', label: 'Best Colleges', subtitle: 'TN | District' },
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50 w-full overflow-x-hidden">
      <div className="container mx-auto px-4 max-w-full">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 text-primary-600 font-bold text-lg md:text-xl">
            <FaGraduationCap className="text-2xl md:text-3xl" />
            <span className="truncate">ChooseMyCollege</span>
          </Link>

          {/* Right side: nav + ChoiceList icon */}
          <div className="flex items-center gap-4">
            <nav className="hidden md:flex items-baseline space-x-8">
              {navLinks.map((link) => (
                <NavLink
                  key={link.path}
                  to={link.path}
                  className={({ isActive }) =>
                    `font-medium transition-colors duration-200 ${
                      isActive
                        ? 'text-primary-600'
                        : 'text-gray-600 hover:text-primary-600'
                    }`
                  }
                >
                  {link.subtitle ? (
                    <div className="flex flex-col leading-tight">
                      <span className="font-bold tracking-wide">{link.label}</span>
                      <span className="text-[10px] text-gray-500 font-normal text-center">{link.subtitle}</span>
                    </div>
                  ) : (
                    <span>{link.label}</span>
                  )}
                </NavLink>
              ))}
              {/* Blog is a static page outside the SPA — plain <a>, not NavLink */}
              <a href="/blog/" className="font-medium text-gray-600 hover:text-primary-600 transition-colors duration-200">
                Blog
              </a>
            </nav>

            {/* Blog icon — mobile only; desktop already has the text link in nav above.
                Static page outside the SPA, so plain <a>, not <Link>. */}
            <a
              href="/blog/"
              title="TNEA Guides & Blog"
              className="md:hidden p-2 text-gray-400 hover:text-blue-600 transition-colors"
              aria-label="Blog"
            >
              <FaNewspaper className="text-base" />
            </a>

            {/* Share icon */}
            <button
              onClick={handleShare}
              title="Share with friends"
              className="p-2 text-gray-400 hover:text-blue-600 transition-colors"
              aria-label="Share app"
            >
              <FaShareAlt className="text-base" />
            </button>

            {/* ChoiceList icon — visible on all screen sizes */}
            <Link to="/choicelist" className="relative p-2 text-gray-600 hover:text-blue-600 transition-colors" title="My ChoiceList">
              <FaHeart className="text-lg text-red-500" />
              {choiceList.length > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-blue-600 text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                  {choiceList.length}
                </span>
              )}
            </Link>
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;

